export const CREDENTIALS_LINK = 'https://www.greeninvoice.co.il/api-docs';